module.exports = __webpack_public_path__ + "static/img/loading.bbdac9cd.gif";